import React from 'react';
import './App.css';
import {createStore} from 'react-hookstore'
import TopNav from './TopNav'
import Header from './Header'
import Pictures from './Pictures'
import News from './News'
import Events from './Events'
import Items from './Items'
import Links from './Links'
import Footer from './Footer'
/*
 */
function App() {
  createStore('language', 0)
  createStore('modal', {
    open: '',
    title: '',
    label: 'title',
    body: 'Loading...'
  })
  createStore('text', null)
  createStore('sidebar', {
    open: false,
    body: <></>
  })
  return (
    <div className="App">
      <div className="main">
        <TopNav/>
        <Header/>
        <Pictures/>
        <News/>
        <Events/>
        <Items/>
        <Links/>
        <Footer/>
      </div>
    </div>
  )
}

export default App;
